import { useEffect, useId, useState } from 'react';
import Flatpickr from 'react-flatpickr';

type DateRangePickerProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  className?: string;
  isError?: boolean;
  errMsg?: any;
  required?: boolean | undefined;
  ranges?: any;
  onChange?: (event: any) => void;
};

export default function DateRangePicker({ ranges, required, errMsg, isError, label, className, onChange, ...restProps }: DateRangePickerProps) {
  const [dateRange, setDateRange] = useState<any>();

  useEffect(() => {
    setDateRange(ranges);
  }, [ranges]);

  const onChangeDate = (event: any) => {
    if (event && event.length >= 2) {
      onChange?.({
        startDate: event[0],
        endDate: event[1]
      });
    }
  };

  return (
    <Flatpickr
      value={dateRange}
      onChange={onChangeDate}
      options={{
        mode: 'range',
        locale: {
          rangeSeparator: ' - ',
          weekdays: {
            shorthand: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
            longhand: ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7']
          },
          months: {
            shorthand: ['Thg 1', 'Thg 2', 'Thg 3', 'Thg 4', 'Thg 5', 'Thg 6', 'Thg 7', 'Thg 8', 'Thg 9', 'Thg 10', 'Thg 11', 'Thg 12'],
            longhand: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12']
          }
        },
        dateFormat: 'd/m/Y'
      }}
      render={({ defaultValue, value, ...props }, ref) => {
        return <CustomInput defaultValue={defaultValue} inputRef={ref} label={label} {...restProps} />;
      }}
    />
  );
}

const CustomInput = ({ label, value, defaultValue, inputRef, ...props }: any) => {
  const id = useId();
  return (
    <div className="form-floating form-floating-outline">
      <input {...props} defaultValue={defaultValue} ref={inputRef} className="form-control flatpickr-input" id={id} />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};
